import setVersions from './setVersions'

export default {
  dashboard: '1.0.0',
  monitoring: '1.0.0',
  apiQuery: '1.0.0',
  jobRest: '1.0.0',
  jobSoap: '1.0.0',
  restToSoap: '1.0.0',
  workflow: '1.0.0',
  dbRegister: '1.0.0',
  credentials: '1.0.0',
  fromTo: '1.0.0',
  parameters: '1.0.0',
  sequences: '1.0.0',
  socketServer: '1.0.0',
  emailServer: '1.0.0',
  clients: '1.0.0',
  users: '1.0.0'
}

export { setVersions }
